import { sortToken } from '../parcelLabel';

/**
 * The short tag printed large on a Parcel label, shown beside the same parcel
 * wherever it appears on screen.
 *
 * WHY IT EXISTS
 *
 * A rider at a doorstep with several parcels in one bag should not have to read
 * a twenty-nine character code off each to find the right one. The app shows
 * this tag next to the stop; the label shows the same tag in a bordered box in
 * large print; the rider matches the two at a glance.
 *
 * It only works if both sides show it. It was printed on the label for a while
 * with nothing on screen to match against, which made it decoration - so this
 * component is the other half, and it deliberately copies the label's bordered,
 * heavy look so the two read as the same thing.
 *
 * The tag is the tail of the permanent parcel code, not a stop number: the label
 * is printed at packing, before any trip exists, so the stop order is not known
 * yet. The code's tail is known at print time and never changes.
 */
export default function ParcelSortTag({ labelCode, className = '' }) {
  const token = sortToken(labelCode);
  if (!token) return null;
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-md border-2 border-current px-1.5 py-0.5 font-mono text-xs font-black tracking-wider ${className}`}
      aria-label={`Parcel tag ${token.split('').join(' ')}`}
      title="Matches the large tag printed on this parcel's label"
    >
      {token}
    </span>
  );
}
